import PropTypes from "prop-types";
import React from "react";

const Input = (props) => {
  return (
    <div>
      {props.title && (
        <p className="text-neutral-700 font-medium mb-1">{props.title}</p>
      )}

      <input
        type={props.type ?? "text"}
        placeholder={props.placeholder}
        className="input input-bordered focus:border-2 focus:outline-none focus:border-baseColor w-full text-neutral-700"
        onChange={props.onChange}
        value={props.value}
        min={props.min}
      />

      {props.error && (
        <p className="text-sm font-medium text-error mt-[2px]">{props.error}</p>
      )}
    </div>
  );
};

export default Input;

Input.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  min: PropTypes.number,
};
